import React, { useContext, useEffect, useState } from "react";
import MaterialTable, { Column } from "material-table";
import { forwardRef } from "react";
import tableIcons from "../../components/Notifications/MaterialTableIcons";
import { getUnverifiedCognitoUser } from "../../services/ApiService";
import { ApplicationContext, ProviderContext } from "../../ApplicationState";
import * as ApiService from '../../services/ApiService';
var _ = require("lodash");

interface ICognitoAttribute {
    name: string;
    value: string;
}

interface ICognitoUserRaw {
    username: string;
    attributes: ICognitoAttribute[];
    userCreateDate: string;
    userLastModifiedDate: string;
    userStatus: string;
}

export interface IUnverifiedUser {
    Username: string;
    email: string;
    firstName: string;
    lastName: string;
    gender: string;
    providerCode: string;
    phone: string;
    userCreateDate: string;
    userLastModifiedDate: string;
    userStatus: string;
}

export const UnverifiedUsers = () => {

    const { providerState } = useContext(ProviderContext);

    const { userState } = useContext(ApplicationContext);

    const [data, setData] = useState<IUnverifiedUser[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    // Mock initial state representing data returned from your C# backend
    // const [data, setData] = useState<IUnverifiedUser[]>([
    //     {
    //         Username: "user_01",
    //         email: "john.doe@example.com",
    //         firstName: "John",
    //         lastName: "Doe",
    //         gender: "Male",
    //         providerCode: "PROV_A",
    //         phone: "+1234567890"
    //     },
    //     {
    //         Username: "user_02",
    //         email: "jane.smith@example.com",
    //         firstName: "Jane",
    //         lastName: "Smith",
    //         gender: "Female",
    //         providerCode: "PROV_B",
    //         phone: "+1987654321"
    //     }
    // ]);

    const columns: Column<IUnverifiedUser>[] = [
        { title: "First Name", field: "firstName" },
        { title: "Last Name", field: "lastName" },
        { title: "Email", field: "email" },
        { title: "Phone", field: "phone" },
        { title: "Gender", field: "gender" },
        { title: "Provider", field: "providerCode" },
        { title: "UserCreateDate", field: "userCreateDate", editable: "never" },
        { title: "UserLastModifiedDate", field: "userLastModifiedDate", editable: "never" },
        { title: "UserStatus", field: "userStatus", editable: "never" }
    ];

    useEffect(() => {
        getUnverifiedUser()
    }, [providerState.providerId])


    const getUnverifiedUser = () => {

        try {
            ApiService.getUnverifiedCognitoUser(
                userState.authenticatedUser,
            ).then(result => {

                console.log('==getUnverifiedCognitoUser== ', result)

                if (result) {
                    const flattenedData = transformCognitoData(result);
                    setData(flattenedData);
                }
                setLoading(false)
            })

        } catch (ex) {
            setLoading(false)
            alert(`Error:- ${ex}`)
        } finally {
            setLoading(false)
        }
    }

    const transformCognitoData = (rawUsers: ICognitoUserRaw[]): IUnverifiedUser[] => {
        return rawUsers.map((user) => {
            // Create a lookup dictionary from the attributes array
            const attrMap = user.attributes.reduce((acc, curr) => {
                acc[curr.name] = curr.value;
                return acc;
            }, {} as Record<string, string>);

            const createddate = new Date(user.userCreateDate);

            // 1. Format the date part: "March 5, 2025"
            const datePart = createddate.toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric"
            });

            // 2. Format the time part in 24-hour style: "13:25"
            const timePart = createddate.toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false // Enforces 24-hour military clock
            });

            // 3. Extract the local timezone abbreviation (e.g., "CST", "EST", "GMT")
            const tzPart = createddate.toLocaleDateString("en-US", { day: 'numeric', timeZoneName: 'short' })
                .split(' ')
                .pop(); // Grabs the timezone abbreviation text at the end
            const userCreationDate = `${datePart} at ${timePart} ${tzPart}`



            const modifieddate = new Date(user.userLastModifiedDate);

            // 1. Format the date part: "March 5, 2025"
            const modifieddatePart = modifieddate.toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric"
            });

            // 2. Format the time part in 24-hour style: "13:25"
            const modifiedtimePart = modifieddate.toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false // Enforces 24-hour military clock
            });

            // 3. Extract the local timezone abbreviation (e.g., "CST", "EST", "GMT")
            const modifiedtzPart = modifieddate.toLocaleDateString("en-US", { day: 'numeric', timeZoneName: 'short' })
                .split(' ')
                .pop(); // Grabs the timezone abbreviation text at the end
            const userlastmodifiedDate = `${modifieddatePart} at ${modifiedtimePart} ${modifiedtzPart}`



            // Map AWS Cognito default naming standards to your table interface
            return {
                Username: user.username,
                email: attrMap["email"] || "",
                firstName: attrMap["given_name"] || "", // Cognito standard for first name
                lastName: attrMap["family_name"] || "", // Cognito standard for last name
                gender: attrMap["gender"] || "",
                providerCode: attrMap["custom:providercode"] || attrMap["providerCode"] || "", // fallback for custom attributes
                phone: attrMap["phone_number"] || "",  // Cognito standard for phone
                userCreateDate: userCreationDate,
                userLastModifiedDate: userlastmodifiedDate,
                userStatus: user.userStatus['value']
            };
        });
    };

    const updateUser = (newData: IUnverifiedUser) => {
        const data = {
            username: newData.Username,
            firstName: newData.firstName,
            lastName: newData.lastName,
            email: newData.email,
            phone: newData.phone,
            providerCode: newData.providerCode || "",
            gender: newData.gender || ""
        }
        try {

            ApiService.updateUnconfirmedUserAttributes(userState.authenticatedUser, data)
                .then((response) => {
                    if (response) {
                        alert('User Updated')
                    }
                    setLoading(false)
                })
                .catch((err) => {
                    setLoading(false)
                    alert(err);
                });

        } catch (ex) {
            setLoading(false)
            alert(`Error:- ${ex}`)
        } finally {
            setLoading(false)
        }

    }

    return (
        <div style={{
            maxWidth: "100%", margin: "20px",
            maxHeight: "100vh", // Keeps container bounds inside the viewport screen
            overflowY: "visible",
        }}>
            <MaterialTable
                icons={tableIcons}
                title="Unverified Users Management"
                columns={columns}
                data={data}
                isLoading={loading}
                options={{
                    actionsColumnIndex: 0, // Places edit/save controls on the far right side
                    paging: true,
                    pageSize: 10,
                    search: true,
                    maxBodyHeight: "90vh", // Restricts table height to 60% of viewport height
                    overflowY: "auto"
                }}
                editable={{
                    onRowUpdate: (newData, oldData) =>
                        new Promise<void>((resolve, reject) => {
                            // 1. Trigger backend API update here
                            // Example: fetch(`/api/users/${oldData.Username}`, { method: 'PUT', body: JSON.stringify(newData) })
                            updateUser(newData)
                            setTimeout(() => {
                                const dataUpdate = [...data];
                                if (oldData) {
                                    const index = oldData?.tableData!.id; // material-table tracks internal indexes here
                                    dataUpdate[index] = newData;
                                    setData(dataUpdate);
                                }
                                resolve();
                            }, 600); // Visual delay simulation
                        })
                }}
            />
        </div>
    );
};
